module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/加入盛泰.c0388cc4.svg";